// 主题格式化函数
export const unionThemeFormat = (theme: string, index: number) =>
  `${theme}${theme ? `（${index}）` : ''}`;

export const roundThemeFormat = (_theme: string, index: number) =>
  `Day${index}`;

export const sarosThemeFormat = (_theme: string, index: number) =>
  `场次${index}`;
